import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CampaignsRoutingModule } from './campaigns-routing.module';
import { ListCampaignsComponent } from './list-campaigns/list-campaigns.component';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditorModule } from '@tinymce/tinymce-angular';
import { EditCampaignComponent } from './edit-campaign/edit-campaign.component';
import { PreviewContentComponent } from './preview-content/preview-content.component';
import { EditTemplateComponent } from './edit-template/edit-template.component';
import { CommunicationContentComponent } from './communication-content/communication-content.component';
import { BlockedDatesComponent } from './blocked-dates/blocked-dates.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  NextServiceDateDialogComponent,
} from './list-campaigns/next-service-date-dialog/next-service-date-dialog.component';

@NgModule({
  declarations: [
    ListCampaignsComponent,
    EditCampaignComponent,
    CommunicationContentComponent,
    PreviewContentComponent,
    EditTemplateComponent,
    BlockedDatesComponent,
    NextServiceDateDialogComponent,
  ],
  imports: [
    CommonModule,
    CampaignsRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    EditorModule,
    FontAwesomeModule,
  ],
})
export class CampaignsModule {
}